import JsonManager from './JsonManager';

class ArticleManager {
  constructor(id) {
    this.id = id;
    this.article = JsonManager.getArticle(id);
    this.project = JsonManager.getProject(id);
  }

  getParagraphs() {
    return this.article.paragraphs;
  }

  hasBullets() {
    return !!this.getBullets().length;
  }

  isOrdered() {
    return this.article.listIsOrdered;
  }

  getTitle() {
    return this.project.titleFull;
  }

  getSubtitle() {
    return this.project.subtitle;
  }

  getBulletsTitle() {
    return this.article.list_title;
  }

  getBullets() {
    return this.article.list_items;
  }
}

export default ArticleManager;



// WEBPACK FOOTER //
// ./src/managers/ArticleManager.js